// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__1T0uM","child":"content_child__15FVH"};